module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/378.65bcb820.png";